import { render, staticRenderFns } from "./ProductDesignFormAccEdit.vue?vue&type=template&id=1cde4ae2&"
import script from "./ProductDesignFormAccEdit.vue?vue&type=script&lang=js&"
export * from "./ProductDesignFormAccEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports